export default __webpack_public_path__ + "static/media/icon_business-intelligence.c1746cb1.svg";